// @ts-nocheck
import React from "react";
import ForecastSelect from "../../ForecastSelect";
import TimeZonePicker from "./TimeZonePicker";
import GraphMobileControls from "../../forecastGraphs/helpers/GraphMobileControls";

// This component renders the header for the asset graph in mobile view

// including forecast selection, variation buttons, and buttons to open time range and dataset modals.
const AssetGraphHeaderMobile = ({
  leadingControl = null,
  activeForecast,
  foreCastSchema,
  onForecastSelect,
  selectedForecasts,
  onSelectionChange,
  onReorderSelection,
  forecastOrder,
  forecastVariation,
  onVariationChange,
  hideChartTools = false,
  timeZoneMode,
  hasAssetTimeZone,
  onTimeZoneChange,
  onOpenTimeRange,
  onOpenDataset,
}) => {
  const variations = foreCastSchema?.[activeForecast]?.variations || [];
  const variationOptions = variations.map((variation) => ({
    key: variation.key,
    label: variation.name,
  }));
  // Render the header with forecast select, variation buttons, and action buttons for mobile view
  return (
    <div className="flex w-full flex-row items-center gap-2">
      {leadingControl}
      <div data-tour="asset-forecast-mobile" className="min-w-0 flex-1">
        <ForecastSelect
          activeForecast={activeForecast}
          foreCastSchema={foreCastSchema}
          onForecastSelect={onForecastSelect}
          selectedForecasts={selectedForecasts}
          onSelectionChange={onSelectionChange}
          onReorder={onReorderSelection}
          forecastOrder={forecastOrder}
        />
      </div>
      {hideChartTools && (
        <div className="ml-auto flex flex-none items-center">
          <TimeZonePicker compact timeZoneMode={timeZoneMode} hasAssetTimeZone={hasAssetTimeZone} onTimeZoneChange={onTimeZoneChange} />
        </div>
      )}
      {!hideChartTools && (
      <GraphMobileControls
        className="relative ml-auto flex flex-none items-center gap-2"
        variationTour="asset-variation-mobile"
        timeRangeTour="asset-timerange-mobile"
        datasetsTour="asset-datasets-mobile"
        variationOptions={variationOptions}
        selectedVariationKey={forecastVariation}
        onSelectVariation={onVariationChange}
        variationButtonClassName="eai-btn-toolbar-icon"
        onOpenTimeRange={onOpenTimeRange}
        onOpenDataset={onOpenDataset}
      />
      )}
    </div>
  );
};

export default AssetGraphHeaderMobile;
